import React, { useRef } from "react"
import { DataGrid, Button, Template } from "devextreme-react"
import {
  Editing,
  Column,
  RequiredRule,
  StateStoring,
  Button as GridButton,
  FilterRow,
  Scrolling,
} from "devextreme-react/data-grid"
import notify from "devextreme/ui/notify"

import { TabItemGridW, LockButton } from "../../shared/StyledComponents"
import { expenseDataStore } from "../../shared/ConcurStore"
import { hasAccessTo } from "../../../authentication"
import { expenseLocker } from "../../operations/concur"
import { faPlus } from "../../shared/icons"

const Settings = () => {
  const expenseGrid = useRef(null)

  const addNewExpenseClickHandler = () => {
    expenseGrid.current.instance.addRow()
  }
  const refreshExpenseGridClickHandler = () => {
    expenseGrid.current.instance.refresh(true)
  }

  const lockButtonRenderHandler = ({ data }) => (
    <LockButton onClick={lockClickHandler(data.id)} lockId={data.lockId} />
  )
  const lockClickHandler = id => async () => {
    try {
      await expenseLocker(id)
      expenseGrid.current.instance.refresh(false)
    } catch (error) {
      notify(`Changing lock status failed: ${error.message}`, "error")
    }
  }
  return (
    <TabItemGridW>
      <DataGrid
        dataSource={expenseDataStore}
        columnAutoWidth={true}
        columnResizingMode="widget"
        hoverStateEnabled={true}
        ref={expenseGrid}
        rowAlternationEnabled={true}
        showBorders={true}
        visible={hasAccessTo("concur.expense.r")}
        onToolbarPreparing={e => {
          e.toolbarOptions.items.unshift({
            location: "before",
            template: "addNewExpense",
          })
          e.toolbarOptions.items.unshift({
            location: "before",
            template: "refreshGrid",
          })
        }}
      >
        <Column dataField="id" dataType="number" allowEditing={false} />
        <Column dataField="title" dataType="string">
          <RequiredRule trim={true} />
        </Column>
        <Column dataField="isActive" dataType="boolean" />
        <Column type="buttons">
          <GridButton name="edit" />
          <GridButton name="delete" />
          <GridButton
            render={lockButtonRenderHandler}
            visible={hasAccessTo("concur.expense.l")}
          />
        </Column>
        <FilterRow visible={true} />
        <Editing
          mode="form"
          useIcons={true}
          allowDeleting={hasAccessTo("concur.expense.d")}
          allowUpdating={hasAccessTo("concur.expense.u")}
        />
        <Scrolling showScrollbar="always" />
        <StateStoring
          enabled={true}
          type="localStorage"
          storageKey="concur-settings-expenses"
        />
        <Template name="refreshGrid">
          <Button icon="refresh" onClick={refreshExpenseGridClickHandler} />
        </Template>
        <Template name="addNewExpense">
          <Button
            icon={faPlus}
            text="Add Expense Module"
            onClick={addNewExpenseClickHandler}
            visible={hasAccessTo("concur.expense.c")}
          />
        </Template>
      </DataGrid>
    </TabItemGridW>
  )
}

export default Settings
